export const renderDropdownValue =
  (placholderText: string) =>
  (value: string | number | unknown | null): any => {
    if (!value) {
      return placholderText;
    }
    return value;
  };
